import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { useSportUrlParams } from '@mwl/core-lib';
import UpcomingFilterIcon from '@public/assets/sportToolbar/icons/upcomingFilter.svg';
import { Button } from '@/components/Button/Button';
import { routes } from '@/constants';
import { getUpcomingFilterAnalytics } from '@/Layouts/SportLayout/components/SportToolbar/components/UpcomingFilter/UpcomingFilter.analytics';
import type { UpcomingFilterProps, UpcomingFilterTab } from './UpcomingFilter.types';
import styles from './UpcomingFilter.module.scss';
const tabs: Array<UpcomingFilterTab> = [{
  key: ['upcoming_1h', '1h'],
  value: 'IN_1_HOUR'
}, {
  key: ['upcoming_3h', '3h'],
  value: 'IN_3_HOURS'
}, {
  key: ['upcoming_12h', '12h'],
  value: 'IN_12_HOURS'
}, {
  key: ['upcoming_24h', '24h'],
  value: 'IN_24_HOURS'
}];
export const UpcomingFilter: FC<UpcomingFilterProps> = ({
  className
}) => {
  const {
    t
  } = useTranslation('sport');
  const {
    upcoming,
    createUpcomingLink
  } = useSportUrlParams({
    routes
  });
  return <div className={cn(styles.root, className)} data-sentry-component="UpcomingFilter" data-sentry-source-file="UpcomingFilter.tsx">
      <div className={styles.title}>
        <UpcomingFilterIcon data-sentry-element="UpcomingFilterIcon" data-sentry-source-file="UpcomingFilter.tsx" />
        <span className={styles.text}>{t('upcoming', 'Upcoming')}</span>
      </div>

      <div className={styles.filters}>
        {tabs.map((tab, index) => {
        const isActive = upcoming === tab.value;
        const href = createUpcomingLink(tab.value);
        const text = t(tab.key);
        return <Button key={index} className={cn(styles.filter, isActive && styles.filterActive)} as="link" href={href} variant="text" rounded shallow analytics={getUpcomingFilterAnalytics({
          text,
          href,
          count: tabs?.length,
          position: index,
          isActive
        })}>
              {text}
            </Button>;
      })}
      </div>
    </div>;
};